module.exports = __webpack_public_path__ + "static/media/volumeOff.9320388a.png";